import type { PropertyFields } from '../types';
import { CardHead } from '../bits';
import { descriptionSections } from './description';
import styles from './DescriptionCard.module.css';

/** „Beschreibung" (D-187): the five marketing texts of the property; hidden when all are empty. */
export function DescriptionCard({ fields }: { fields: PropertyFields }) {
  const sections = descriptionSections(fields);
  if (sections.length === 0) return null;
  return (
    <section className={styles.card} aria-labelledby="property-description">
      <CardHead eyebrow="Beschreibung" id="property-description" />
      <div className={styles.sections}>
        {sections.map((section) => (
          <div key={section.key} className={styles.section}>
            <h3 className={styles.title}>{section.label}</h3>
            <p className={styles.text}>{section.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
